import React, { useEffect, useState } from "react";
import "./css/login.style.css";
import media from "../../media";
import ByEmailPassword from "./byEmailPassword";
import SubmitOTP from "./submitOTP";
import ByPhoneNumber from "./byPhoneNumber";
import ConditionsModal from "./conditionsModal";
import { useDispatch, useSelector } from "react-redux";
import {
  loginAdminThunk,
  loginByPhoneThunk,
} from "../../store/thunks/authThunk";
import { setStorage } from "../../utils/secureStorage";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Loader from "../../components/atoms/Loader";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { token, user, status, error, expiresIn, refreshToken, loading } =
    useSelector((state) => state?.auth || {});

  const [errors, setErrors] = useState({});
  const [terms, setTerms] = useState(false);
  const [counter, setCounter] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [OTP, setOTP] = useState(false);
  const [phone, setPhone] = useState(false);

  useEffect(() => {
    let timer;
    if (isActive && counter > 0) {
      timer = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
    } else if (counter === 0) {
      clearInterval(timer);
      setIsActive(false);
    }

    return () => clearInterval(timer);
  }, [isActive, counter]);

  const startCountdown = () => {
    setCounter(30);
    setIsActive(true);
  };
  const [formState, setLoginState] = useState({
    userName: "",
    userPassword: "",
    isOTP: false,
  });
  const [otpSubmitState, setOtpSubmitState] = useState({
    userName: "",
    userPassword: "",
  });

  const handleLoginEmail = (e) => {
    e.preventDefault();
    if (!phone) {
      setOTP(false);
      if (formState?.userName && formState?.userPassword) {
        setErrors({});
        dispatch(
          loginAdminThunk({
            userName: formState?.userName,
            password: formState?.userPassword,
            otpLogIn: phone,
          })
        );
      } else {
        setErrors({
          ...errors,
          userName: formState?.userName ? "" : "Email is Mandatory",
          userPassword: formState?.userPassword ? "" : "Password is Mandatory",
        });
      }
    }
  };

  useEffect(() => {
    setStorage("isLogin", {
      token,
      user,
      status,
      error,
      expiresIn,
      refreshToken,
    });
    token && navigate("/");
  }, [token]);
  if (loading) return <Loader />;
  return (
    <>
      <div className="login-page">
        <div className="d-flex justify-content-center align-items-center min-h-full-screen flex-column">
          <div className="MuiPaper-root jss21">
            <div className="MuiGrid-root MuiGrid-container">
              <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-5 MuiGrid-grid-md-5 MuiGrid-grid-lg-5">
                <div className="p-8 flex justify-center items-center h-full">
                  <img src={media.ak_logo} className="max-h-70px" alt="LOGO" />
                </div>
              </div>
              <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-7 MuiGrid-grid-md-7 MuiGrid-grid-lg-7">
                <div className="p-8 h-full bg-light-gray relative">
                  <form className="form login-form" id="contact" name="contact">
                    {OTP ? (
                      <>
                        <ByPhoneNumber
                          phone={phone}
                          OTP={OTP}
                          errors={errors}
                          setErrors={setErrors}
                          formState={formState}
                          setLoginState={setLoginState}
                        />
                        {phone && terms && (
                          <SubmitOTP
                            errors={errors}
                            setErrors={setErrors}
                            formState={formState}
                            setLoginState={setLoginState}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        <ByEmailPassword
                          errors={errors}
                          setErrors={setErrors}
                          formState={formState}
                          setLoginState={setLoginState}
                        />
                      </>
                    )}

                    {OTP && (
                      <div className="form-group form-check">
                        <div className="form-check-label font-weight-bolder">
                          <input
                            className="form-check-input mr-3"
                            type="checkbox"
                            checked={terms}
                            onChange={(e) => {
                              setTerms(e.target.checked);
                            }}
                          />
                          I agree to the
                          <span
                            className="cursor-pointer text-info"
                            data-target="#termsAndConditions"
                            data-toggle="modal"
                          >
                            <u> Terms and Conditions</u>
                          </span>
                        </div>
                      </div>
                    )}
                    {OTP && (
                      <div className="form-group mb-3">
                        {phone && (
                          <span className="form-check-label font-weight-bolder">
                            {counter > 0 ? (
                              <div className="text-muted">
                                You can request new OTP in {counter} seconds
                              </div>
                            ) : (
                              <p
                                className="cursor-pointer font-weight-bolder text-primary"
                                onClick={(e) => {
                                  dispatch(
                                    loginByPhoneThunk({
                                      userName: formState?.phoneNumber,
                                    })
                                  );
                                  startCountdown();
                                }}
                              >
                                <u>Resend OTP</u>
                              </p>
                            )}
                          </span>
                        )}
                      </div>
                    )}

                    <div className="pb-lg-0 pb-5">
                      {!OTP && (
                        <button
                          type="button"
                          className="btn btn-primary font-weight-bolder font-size-h7 px-5 py-2 mr-3"
                          onClick={(e) => {
                            handleLoginEmail(e);
                          }}
                        >
                          Sign In
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn btn-primary font-weight-bolder font-size-h7 px-5 py-2"
                        onClick={(e) => {
                          e.preventDefault();
                          setOTP(!OTP);
                          setLoginState({
                            ...formState,
                            userName: "",
                            userPassword: "",
                            phoneNumber: "",
                            otp: "",
                          });
                          setPhone(false);
                          setIsActive(false);
                          setCounter(0);
                        }}
                      >
                        {!OTP ? "Login via Phone Number" : "Login via email"}
                      </button>

                      {OTP &&
                        (!phone ? (
                          <button
                            type="button"
                            className="btn btn-primary font-weight-bolder font-size-h7 px-5 py-2 ml-3"
                            onClick={(e) => {
                              e.preventDefault();
                              setErrors({
                                ...errors,
                                phoneNumber: formState?.phoneNumber
                                  ? formState?.phoneNumber.match(/^\d{10}$/)
                                    ? ""
                                    : "Invalid phone number"
                                  : "Phone Number is Mandatory",
                              });
                              if (!terms)
                                message.info(
                                  "Please Accept Terms & Conditions to Proceed"
                                );
                              if (
                                terms &&
                                OTP &&
                                formState?.phoneNumber?.match(/^\d{10}$/)
                              ) {
                                setOtpSubmitState(formState);
                                setPhone(true);
                                dispatch(
                                  loginByPhoneThunk({
                                    userName: formState?.phoneNumber,
                                  })
                                );
                              }
                            }}
                          >
                            Request OTP
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary font-weight-bolder font-size-h7 px-5 py-2 mx-3"
                            onClick={(e) => {
                              e.preventDefault();
                              setErrors({
                                ...errors,
                                otp: formState?.otp
                                  ? formState?.otp?.match(/^\d{6}$/)
                                    ? ""
                                    : "Invalid OTP"
                                  : "OTP is Mandatory",
                              });
                              if (!terms)
                                message.info(
                                  "Please Accept Terms & Conditions to Proceed"
                                );
                              if (
                                terms &&
                                phone &&
                                formState?.otp?.match(/^\d{6}$/) &&
                                formState?.phoneNumber
                              ) {
                                dispatch(
                                  loginAdminThunk({
                                    userName: formState?.phoneNumber,
                                    password: formState?.otp,
                                    otpLogIn: true,
                                  })
                                );
                              }
                            }}
                          >
                            Sign In
                          </button>
                        ))}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConditionsModal
        data-toggle="modal"
        data-target="#termsAndConditions"
        setTerms={setTerms}
        terms={terms}
      />
    </>
  );
};

export default Login;
